<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Stock Item</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <div class="pt-5">
          <SearchBox v-model="searchMenu" placeholder="Cari Menu" class-add="w-full" />
          <LocalFilterLane :items="allItemCategories" class-add="my-3" @setCurrentItem="setCurrentFilterCategory" />
          <div
            class="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 max-h-[calc(100dvh-290px)] overflow-y-auto pb-24">
            <ProductCard v-for="item in filteredItems" :key="item.id" :btnAddItem="'add-item-' + item.id"
              :productName="item.name" :product="item" :productPrice="formatRupiah(item.sale_price)" :image="item.image" @add-order="addMixItem" :isClose="isClose" />
          </div>
        </div>
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white"
            @click="closeModal" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '../form/SubmitButton.vue';
import { formatRupiah } from '@/helpers/formatRupiah';
import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import LocalFilterLane from '@/views/pages/new-transaction/order/LocalFilterLane.vue';
import ProductCard from '@/views/pages/new-transaction/order/ProductCard.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ModalProductStock",
  components: {
    SubmitButton, SearchBox, LocalFilterLane, ProductCard
  },
  data() {
    return {
      showModal: true,
      selectedCategory: null,
      searchMenu: '',
    }
  },
  async created() {
    await this.$store.dispatch("items/fetchItems", { limit: 1000 });
    await this.$store.dispatch("item_categories/fetchItemCategories", { limit: 1000 });
  },
  computed: {
    ...mapGetters('items', ['allItems']),
    ...mapGetters('item_categories', ['allItemCategories']),
    filteredItems() {
      let result = this.allItems.map(item => {
        return {
          ...item,
          itemCategory: this.allItemCategories.find(
            (category) => category.id === item.item_category_id
          ),
          stock: item.stockMovements.length > 0 ? item.stockMovements[0].closing_balance : 0,
        };
      });
      if (this.searchMenu)
        result = result.filter(
          (item) =>
            item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
        );
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.item_category_id === this.selectedCategory
        );
      }
      return result;
    },
  },
  methods: {
    ...mapActions("items", ["fetchItems"]),
    ...mapActions("item_categories", ["fetchItemCategories"]),
    formatRupiah,
    setCurrentFilterCategory(item) {
      this.selectedCategory = item;
    },
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
  }
}
</script>
